"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = exports.size = void 0;
var get_canvas_1 = require("./get-canvas");
exports.size = 32;
function render(scene, container, preloader) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var debug = scene.debug, _e = scene.map, base = _e.base, tables = _e.tables, squares = _e.squares, screen = scene.screen;
    var canvas = get_canvas_1.getCanvas(container, screen);
    var ctx = canvas.getContext('2d');
    if (!ctx)
        return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    var indexSquareMap = {};
    try {
        for (var squares_1 = __values(squares), squares_1_1 = squares_1.next(); !squares_1_1.done; squares_1_1 = squares_1.next()) {
            var square = squares_1_1.value;
            indexSquareMap[square.index] = square;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (squares_1_1 && !squares_1_1.done && (_a = squares_1.return)) _a.call(squares_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var front = tables && tables[0];
    var row = front && front.length;
    var column = front && front[0] && front[0].length;
    var width = Math.min(canvas.width, column * exports.size);
    var height = Math.min(canvas.height, row * exports.size);
    var baseImage = preloader && preloader.getImage(base);
    var pattern = baseImage && ctx.createPattern(baseImage, 'repeat');
    if (pattern) {
        ctx.fillStyle = pattern;
        ctx.fillRect(0, 0, width, height);
    }
    if (debug) {
        ctx.fillStyle = 'white';
        for (var y = 0; y < row; y++) {
            ctx.fillRect(0, y * exports.size - 1, canvas.width, 2);
        }
        for (var x = 0; x < column; x++) {
            ctx.fillRect(x * exports.size - 1, 0, 2, canvas.height);
        }
    }
    try {
        for (var _f = __values(__spread(tables).reverse()), _g = _f.next(); !_g.done; _g = _f.next()) {
            var table = _g.value;
            try {
                for (var _h = (e_3 = void 0, __values(table.entries())), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var _k = __read(_j.value, 2), y = _k[0], row_1 = _k[1];
                    try {
                        for (var _l = (e_4 = void 0, __values(row_1.entries())), _m = _l.next(); !_m.done; _m = _l.next()) {
                            var _o = __read(_m.value, 2), x = _o[0], index = _o[1];
                            if (index < 0)
                                continue;
                            var square = indexSquareMap[index];
                            if (!square)
                                continue;
                            var placement = square.placement;
                            var image = preloader && preloader.getImage(index);
                            if (!image)
                                continue;
                            var collider = getCollider(placement);
                            var edge = debug ? 1 : 0;
                            var left = x * exports.size + edge;
                            var top_1 = y * exports.size + edge;
                            var len = exports.size - 2 * edge;
                            if (debug && collider > -1) {
                                ctx.strokeStyle = collider === 1 ? 'red' : 'white';
                                ctx.lineWidth = edge * 2;
                                ctx.strokeRect(left, top_1, len, len);
                            }
                            ctx.drawImage(image, edge, edge, len, len, left, top_1, len, len);
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
exports.render = render;
function getCollider(placement) {
    switch (placement.type) {
        case 'Wall':
        case 'Barrier':
            return 1;
        case 'Ground':
        case 'Road':
            return 0;
        case 'Rug':
        case 'Float':
        case 'Sky':
        default:
            return -1;
    }
}
//# sourceMappingURL=render.js.map